<template>
  <b-container>
    <b-collapse v-model="showActions">
      <div class="mt-4 mb-2">
        <b-button
          v-for="{action, float, title, variant, text} of actions"
          :key="action"
          :class="['ml-1', `float-${float}`]"
          size="sm"
          @click="handleAction(action)"
          :title="title"
          :variant="variant"
        >{{text}}</b-button>
        <br />
      </div>
    </b-collapse>

    <b-container class="mt-4">
      <b-table
        id="my-table"
        :items="jobs"
        :per-page="perPage"
        :current-page="currentPage"
        primary-key="id"
        small
        hover
        selectable
        :select-mode="selectMode"
        :fields="columns"
        @row-selected="onRowSelected"
        :sort-compare="cmpStatus"
        sticky-header="70vh"
        head-variant="light"
        ref="table"
      >
        <template v-slot:cell(status)="data">
          <span :class="statusColour(data.value)">{{data.value}}</span>
        </template>

        <template v-slot:cell(selected)="{ rowSelected }">
          <Checkmark :ticked="rowSelected" />
        </template>

        <template v-slot:cell(user)="{item}">
          <span v-if="item.usergroup === 'LOCAL'">{{item.user}}</span>
          <span v-else>
            <i>{{item.usergroup}}:</i>
            {{item.user}}
          </span>
        </template>
      </b-table>

      <b-form-radio-group
        v-model="selectMode"
        buttons
        size="sm"
        class="float-right mr-3"
        :options="selectOptions"
        title="Selection mode"
      />

      <b-form-checkbox
        v-if="selectMode === 'range'"
        v-model="selectAll"
        size="sm"
        class="float-right mr-3 mt-2"
      >Select all</b-form-checkbox>

      <b-button
        size="sm"
        @click="updateList()"
        class="float-left ml-3"
        variant="outline-secondary"
        title="Refresh list"
      >
        <b-icon-arrow-repeat />
      </b-button>

      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
        align="center"
        first-number
        last-number
      />
    </b-container>

    <b-collapse v-model="showActions" v-if="selectMode==='single'">
      <div v-if="job">
        <EmbedPreview v-if="job.status === 'finished'" :job-id="job.id" />
        <EditJob :job="job" />
        <JobFileSizes :job-id="job.id" />


        <JobLog
          :job-id="job.id"
          :allowdetails="job.status === 'finished' || job.status === 'error' "
        />
      </div>
    </b-collapse>

    <b-container v-if="selectMode=='single'" />
  </b-container>
</template>

<script>
import JobLog from "@/components/JobLog.vue";
import EmbedPreview from "@/components/EmbedPreview.vue";
import EditJob from "@/components/EditJob.vue";
import Checkmark from "@/components/Checkmark.vue";
import JobFileSizes from "@/components/JobFileSizes.vue";

import * as bs from 'bootstrap-vue';
import Vue from 'vue';

[
    bs.TablePlugin,
    bs.PaginationPlugin,
    bs.ButtonPlugin,
    bs.FormCheckboxPlugin,
    bs.FormRadioPlugin,

].forEach(p=> Vue.use(p))

export default {
  components: { JobLog, EmbedPreview, EditJob, Checkmark, JobFileSizes },
  beforeRouteEnter (t, f, next){ next(vm => vm.$api.is('logged_in') ? next() : (location.href = vm.$api.login()))},
  created() {
    this.updateList();
  },
  data() {
    return {
      columns: [
        { key: "selected", label: "" },
        { key: "id", label: "ID" },
        { key: "name", sortable: true },
        { key: "status", sortable: true },
        { key: "user", sortable: true },
        // { key: "usergroup", sortable: true },
        { key: "worker", sortable: true }
      ],
      actions: [
        {
          action: "accept",
          float: "right",
          variant: "success",
          text: "Accept",
          title: "Accept job and add it to archive"
        },
        {
          action: "restart",
          float: "right",
          variant: "outline-info",
          text: "Restart",
          title: "Restart finished/in progress job"
        },
        {
          action: "clear_worker",
          float: "right",
          variant: "outline-info",
          text: "Release",
          title: "Release the job from its assigned worker"
        },
        {
          action: "reject",
          float: "left",
          variant: "danger",
          text: "Delete",
          title: "Delete job"
        }
      ],
      jobs: [],
      selection: [],
      perPageDefault: 15,
      currentPage: 1,
      selectMode: "single",
      selectOptions: [
        { text: "Single", value: "single" },
        { text: "Batch", value: "range" }
      ],
      dlSizes: 0
    };
  },
  computed: {
    rows() {
      return this.jobs.length;
    },
    job(){
      return this.selectMode == 'single' ? this.selection[0] : null;
    },
    showActions: {
      get() {
        return this.selection.length > 0;
      },
      set: () => {}
    },
    perPage() {
      return this.selectMode === "single" ? this.perPageDefault : this.rows;
    },
    selectAll: {
      get() {
        return this.selection.length === this.jobs.length;
      },
      set(selected) {
        if (selected) this.$refs.table.selectAllRows();
        else this.$refs.table.clearSelected();
      }
    }
  },
  methods: {
    updateList() {
      let self = this;
      this.$api.activeJobs().then(j => {
        for (let job of j.jobs) {
          let { started, finished, error } = job;
          if (error == 1) job.status = "error";
          else if (finished == 1) job.status = "finished";
          else if (started == 1) job.status = "processing";
          else job.status = "queued";
        }
        self.jobs = j.jobs;
      });
    },
    statusColour(status) {
      switch (status) {
        case "error":
          return "text-danger";
        case "finished":
          return "text-success";
        case "processing":
          return "text-info";
      }
    },
    cmpStatus(a, b, key) {
      if (key !== "status") return null;
      const precedence = ["queued", "processing", "error", "finished"];
      let a1 = precedence.indexOf(a["status"]);
      let b1 = precedence.indexOf(b["status"]);
      return a1 < b1 ? -1 : a1 > b1 ? 1 : 0;
    },
    onRowSelected(items) {
      this.selection = items;
    },
    handleAction(act) {
      if (this.selectMode === "single")
        this.handleOneAction(act, this.selection[0]);
      else for (let i of this.selection) this.handleOneAction(act, i);
    },
    handleOneAction(act, item) {
      this.$api.jobAction(act, item.id);
      switch (act) {
        case "clear_worker":
          item.worker = null;
          break;
        case "restart":
          item.status = "queued";
          break;
        case "accept":
        case "reject":
          this.jobs.splice(this.jobs.indexOf(item), 1);
          break;
      }
    }
  }
};
</script>

<style>
</style>
